module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.tag) ? _c('h1', [_c('strong', [_vm._v("Tag:")]), _vm._v(" " + _vm._s(_vm.tag.name))]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "searchResults",
    class: !_vm.loading ? '' : 'loading'
  }, [_vm._l((_vm.results), function(result) {
    return _c('search-result', {
      key: result.slug,
      attrs: {
        "result": result
      }
    })
  }), _vm._v(" "), (!_vm.results || !_vm.results.length) ? _c('div', [_c('h2', [_vm._v("No Results")]), _vm._v(" "), _c('p', [_vm._v("Please try a search")])]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 1) ? _c('pagination', {
    attrs: {
      "totalPages": _vm.totalPages
    }
  }) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63d5589c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tag.vue
// module id = 786
// module chunks = 1